export const transliterateRegex = /^[a-zA-Z]+$/;
export const fieldRegex = /^[0-9.(,+)-S]+$/;
